import { motion } from "framer-motion";
import { Building2, Users, ShieldCheck } from "lucide-react";

const audiences = [
  {
    icon: Building2,
    text: "CA firms managing multiple clients on Tally",
  },
  {
    icon: Users,
    text: "Companies with 2+ accountants and heavy voucher volume",
  },
  {
    icon: ShieldCheck,
    text: "Seniors who want to stop spending hours locating and fixing entry mistakes by juniors",
  },
];

const WhoItsFor = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-narrow mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Built for CA firms, not just "any business"
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {audiences.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex flex-col items-center text-center p-6 rounded-xl bg-secondary/50 border border-border"
            >
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <item.icon className="w-6 h-6 text-primary" />
              </div>
              <p className="text-foreground font-medium">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;
